<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Loyal to the Sky</title>
<link href="CSS_1.css" rel="stylesheet" type="text/css"/>
<div class="chapter" id="d14e109">
<p class="center" id="d7e2026"><span><i>for my parents, Rosemund and Frank Handler, who taught me, by example, to open my mind and then speak it</i></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?7bfad4e4